var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomebotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.2163,
    r: 24,
    fill: "#1E1C23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44.4954C35.1998 44.4954 44.2791 35.4161 44.2791 24.2163C44.2791 13.0165 35.1998 3.93724 24 3.93724C12.8002 3.93724 3.72093 13.0165 3.72093 24.2163C3.72093 35.4161 12.8002 44.4954 24 44.4954ZM24 48.2163C37.2548 48.2163 48 37.4711 48 24.2163C48 10.9615 37.2548 0.216309 24 0.216309C10.7452 0.216309 0 10.9615 0 24.2163C0 37.4711 10.7452 48.2163 24 48.2163Z",
    fill: "url(#paint0_linear_126_31838)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_31838)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.1183,
    cy: 16.0612,
    r: 6.60465,
    fill: "#741D4A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.1192,
    cy: 16.0611,
    r: 4.74419,
    fill: "#DB1E78"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7431 25.6981C25.7431 27.2244 26.9792 28.4604 28.5051 28.4604C30.031 28.4604 31.2671 27.2221 31.2671 25.6981C31.2671 24.1718 30.031 22.9336 28.5051 22.9336C26.9815 22.9336 25.7431 24.1695 25.7431 25.6981ZM16.7848 25.6981C16.7848 27.2244 18.0208 28.4604 19.5467 28.4604C21.0726 28.4604 22.3087 27.2221 22.3087 25.6981C22.3087 24.1718 21.0726 22.9336 19.5467 22.9336C18.0208 22.9336 16.7848 24.1695 16.7848 25.6981ZM19.8946 36.0044H16.8729C15.8827 36.0044 15.0803 35.2006 15.0803 34.2086V31.0507H14.0135C13.4802 31.0507 13.0488 30.6186 13.0488 30.0842V26.1744C13.0488 25.6401 13.4802 25.208 14.0135 25.208H15.0803V21.3748C15.0803 20.3828 15.8827 19.5813 16.8729 19.5813H23.4867V18.4848C22.1904 18.2223 21.2164 17.077 21.2164 15.704C21.2164 14.1359 22.4849 12.8674 24.0503 12.8674C25.6156 12.8674 26.8864 14.1359 26.8864 15.704C26.8864 17.1165 25.8545 18.2873 24.5025 18.5057V19.5813H31.1372C32.1274 19.5813 32.9298 20.3851 32.9298 21.3748V25.208H33.9826C34.5183 25.208 34.9497 25.6401 34.9497 26.1744V30.0842C34.9497 30.6186 34.516 31.0507 33.9826 31.0507H32.9298V34.2086C32.9298 35.2006 32.1251 36.0044 31.1372 36.0044H28.141H19.8946ZM18.5472 31.0158C17.942 31.0158 17.4503 31.5176 17.4503 32.117V32.2843C17.4503 32.8929 17.9443 33.3854 18.5472 33.3854H29.7574C30.3626 33.3854 30.8543 32.8836 30.8543 32.2843V32.117C30.8543 31.5083 30.3603 31.0158 29.7574 31.0158H18.5472Z",
    fill: "#FAF5F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_31838",
    x1: 34.9714,
    y1: 3.87345,
    x2: 11.2,
    y2: 44.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F51E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CE14BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_31838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2093,
    height: 13.2093,
    fill: "white",
    transform: "translate(17.5137 9.14648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebotIcon);
export default __webpack_public_path__ + "static/media/homebot-icon.d2a7b17bf9107acb3dae7204eb569f61.svg";
export { ForwardRef as ReactComponent };